import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const StyledAlertPane = styled(Box).attrs({
  padding: '15px',
  backgroundColor: 'foreground',
  borderRight: '1px solid',
  borderColor: 'lightLineDivider',
})``;

export const StyledChatPane = styled(Box).attrs({
  height: '100%',
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
  overflow: 'hidden',
})``;
